const SERIAL_NORMALIZE_RE = /[^A-Za-z0-9]/g;

/** Canonical serial: alphanumeric only, no spaces or punctuation. */
export function normalizeReaderSerialNumber(value: string): string {
  return value.replace(SERIAL_NORMALIZE_RE, "");
}

function groupSerial(
  canonical: string,
  groups: number[],
  separator = " ",
): string {
  const parts: string[] = [];
  let index = 0;

  for (const size of groups) {
    if (index >= canonical.length) {
      break;
    }
    parts.push(canonical.slice(index, index + size));
    index += size;
  }

  if (index < canonical.length) {
    parts.push(canonical.slice(index));
  }

  return parts.join(separator);
}

/** Provider-specific display formatting for canonical serial numbers. */
export function formatReaderSerialNumber(
  canonical: string,
  provider: string,
): string {
  switch (provider.toUpperCase()) {
    case "SUMUP":
      return groupSerial(canonical, [5, 4, 4, 4]);
    default:
      return canonical;
  }
}

/** Last N characters of the canonical serial (for compact table display). */
export function readerSerialSuffix(serial: string, length = 4): string {
  const normalized = normalizeReaderSerialNumber(serial);
  if (normalized.length <= length) {
    return normalized;
  }
  return normalized.slice(-length);
}

export function readerSerialMatchesQuery(
  canonicalSerial: string,
  query: string,
): boolean {
  const normalizedQuery = normalizeReaderSerialNumber(query).toLowerCase();
  if (!normalizedQuery) {
    return true;
  }
  return canonicalSerial.toLowerCase().includes(normalizedQuery);
}
